import React from 'react';
import { Spinner as NBSpinner } from "native-base";

export class Spinner extends React.PureComponent {
    static propTypes = {};

    getSize() {
        let { size, h2, h3, h4 } = this.props;

        if (size) { return size; }
        if (h4) { return "xs2"; }
        if (h3) { return "xs"; }
        if (h2) { return "sm"; }

        return "md"
    }

    render() {
        let { size, h1, h2, h3, h4, ...props } = this.props;

        return (
            <NBSpinner size={ this.getSize() } { ...props } />
        );
    }
}